import useAuthStore from '../store/authStore';
import { getModule, PermissionActionKey } from '../config/permissionModules';

/**
 * User có quyền `${moduleKey}.${action}` không. Super admin luôn có toàn quyền.
 * Action phải được khai báo trong module (PERMISSION_MODULES), nếu không sẽ luôn
 * từ chối, vì không ai được gán quyền đó trên màn Nhóm quyền.
 */
export function checkPermission(
    permissions: string[],
    isSuperAdmin: boolean,
    moduleKey: string,
    action: PermissionActionKey
): boolean {
    const declared = !!getModule(moduleKey)?.actions.includes(action);
    // Cảnh báo cả khi là super admin, để dev đăng nhập admin vẫn thấy gõ sai tên quyền
    if (!declared && process.env.NODE_ENV !== 'production') {
        console.warn(`[usePermission] "${moduleKey}.${action}" chưa được khai báo trong PERMISSION_MODULES`);
    }
    if (isSuperAdmin) return true;
    return declared && permissions.includes(`${moduleKey}.${action}`);
}

/**
 * Kiểm tra quyền thao tác (nút Thêm / Sửa / Xóa...) của 1 module.
 *
 *   const { can } = usePermission('care');
 *   {can('delete') && <Button danger ... />}
 */
export function usePermission(moduleKey: string) {
    const { permissions, isSuperAdmin } = useAuthStore();
    const can = (action: PermissionActionKey) => checkPermission(permissions, isSuperAdmin, moduleKey, action);
    return { can };
}
